import React from 'react';
import { Translation } from 'react-i18next';
import { Spin } from 'antd';

export default function LoadingSmall(props) {
  return (
    <Translation>
      {(t) => (
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', flex: 1 }}>
            <div style={{ margin: 'auto' }}>
              <Spin size='large' style={{ marginRight: '12px' }} />
              {t('feedback_loading')}
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
